import React from 'react';
import { Card, CardContent } from '../ui/card';

export const PatternsSummary = ({ totalStories, archetypes, countries }) => {
  const archetypeKeys = Object.keys(archetypes || {});
  const archetypeLabel = archetypeKeys.join(' · ');
  const countryCount = Object.keys(countries || {}).length;

  return (
    <div className="grid md:grid-cols-3 gap-4 mb-6" data-testid="patterns-summary">
      <Card className="bg-gradient-to-br from-[#07743F] to-[#0a8f4d] text-white">
        <CardContent className="p-5">
          <p className="text-xs uppercase tracking-wide opacity-90">Stories analysed</p>
          <p className="text-4xl font-bold mt-1">{totalStories}</p>
          <p className="text-xs opacity-80 mt-1">With full narrative expansion</p>
        </CardContent>
      </Card>
      <Card className="bg-gradient-to-br from-[#E4E517] to-[#f3f25a] text-gray-900">
        <CardContent className="p-5">
          <p className="text-xs uppercase tracking-wide opacity-80">Archetypes mapped</p>
          <p className="text-4xl font-bold mt-1">{archetypeKeys.length}</p>
          <p className="text-xs opacity-80 mt-1">{archetypeLabel}</p>
        </CardContent>
      </Card>
      <Card className="bg-gradient-to-br from-[#58595B] to-[#3a3b3c] text-white">
        <CardContent className="p-5">
          <p className="text-xs uppercase tracking-wide opacity-90">Countries represented</p>
          <p className="text-4xl font-bold mt-1">{countryCount}</p>
          <p className="text-xs opacity-80 mt-1">Across the continent</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PatternsSummary;
